import { useEffect, useState, useRef } from "react";
import { useTranslation } from 'react-i18next'
import { useCompanyInfo } from "../../../Providers/CompanyInfoProvider";
import { CiMenuFries } from "react-icons/ci";
import { useNavigate } from "react-router-dom";
import { GoSearch } from "react-icons/go";
import { useShop } from "../../../Providers/ShopProvider";
import { useParams } from "../../../Providers/ParamsProvider";
import TopBarMobileOptions from "./Components/TopBarMobileOptions";
import { RxCross2 } from "react-icons/rx";
import TopBarMobileSearchingResults from "./TopBarMobileSearchingResults";
import useSearchingResults from "../../HomePage/Hooks/useSearchingResults";
import LoadingSpinner from "../../Components/LoadingSpinner";
import useCommonFunctions from "../../../Pages/Shop/Hooks/MobileAndDesktopCommon/useCommonFunctions";
import { useAuth } from "../../../Providers/AuthProvider";
import useWarehouseOperations from "../../../Hooks/useWarehouseOperations";

import '../Styles/MobileBarsStyles.css'
import MobileWarehouseSelectorModal from "../MobileWarehouseSelectorModal";
import ZipCodeInputModal from "../../Components/Modals/ZipCodeInputModal";

const TopBarMobile = () => {
    const { authState } = useAuth()
    const topBarOptionsRef = useRef(null)
    const searchingProductRef = useRef(null)
    const navigate = useNavigate()
    const { searchingQueryCharNumber } = useParams()
    const { companyInfoData } = useCompanyInfo()
    const { t } = useTranslation()
    const { productsFilter, handleGetProductsFromSearchingBar, setProductsFilter, clearProductsFilter } = useShop()
    const [textSearch, setTextSearch] = useState(productsFilter.SearchingQuery ? productsFilter.SearchingQuery : "")
    const [isOptionsExpended, setIsOptionsExpended] = useState(false)
    const [hideProductList, setHideProductList] = useState(false)
    const { result, loading, products, isProductsLoaded, productsRelatesSuppliers, productsCategories, handleGetSearchingResult } = useSearchingResults(textSearch)
    const { NotificationSection } = useCommonFunctions()
    const { findSelectedWarehouseName } = useWarehouseOperations()
    const [showWarehouseSelectorModal, setShowWarehouseSelectorModal] = useState(false)
    const [showZipCodeInput, setShowZipCodeInput] = useState(false)

    useEffect(() => {
        findSelectedWarehouseName(authState.whId) //DK : to tutaj musi być aby ustawic selectedWarehouse bo selector jest ukryty w popup i trzeba to mimo wszystko ustawić
    }, [[], authState.whId])

    useEffect(() => {
        function handleClick(e) {
            if (topBarOptionsRef.current && !topBarOptionsRef.current.contains(e.target)) {
                setIsOptionsExpended(false)
            }
        }
        if (isOptionsExpended) {
            document.addEventListener("mousedown", handleClick)
        }
        else {
            document.removeEventListener("mousedown", handleClick)
        }
        return () => document.removeEventListener("mousedown", handleClick)
    }, [isOptionsExpended])

    useEffect(() => {
        function handleClick(e) {
            if (searchingProductRef.current && !searchingProductRef.current.contains(e.target)) {
                setHideProductList(true)
            }
        }
        if (!hideProductList && isProductsLoaded) {
            document.addEventListener("mousedown", handleClick)
        }
        return () => {
            document.removeEventListener("mousedown", handleClick)
        }
    }, [hideProductList, isProductsLoaded])


    useEffect(() => {
        setTextSearch(productsFilter.SearchingQuery ? productsFilter.SearchingQuery : "")
    }, [productsFilter.SearchingQuery])

    useEffect(() => {
        if (textSearch && textSearch.length > 0) {
            setHideProductList(false)
        }
    }, [textSearch])

    const handleReDirect = (path, isDirect) => {
        setIsOptionsExpended(false)
        if (path == '/shop') {
            clearProductsFilter()
        }
        if (isDirect) {
            navigate(path)
        }
        else {
            window.open(path, '_blank')
        }
    }

    const handleSearch = (e, allArticlesFilterClick, allArticle = false) => {
        if (e && e.key !== "Enter") {
            return
        }
        if (allArticlesFilterClick) { //klikniecie przycisku tylko odświeża produkty w query
            setProductsFilter(prev => ({
                ...prev,
                AllArticles: true
            }))
            handleGetSearchingResult(textSearch, true, null)
            return
        }
        if (textSearch.length >= searchingQueryCharNumber) {
            handleGetProductsFromSearchingBar(textSearch, allArticle) //tutaj wszystkie produkty na zamówienie
            handleReDirect(`/Shop?q=${textSearch}`, true)
        }
    }

    const handleCleatQuery = () => {
        setTextSearch("")
        navigate('/Shop')
    }

    let searchPlaceholderText = searchingQueryCharNumber <= 1 ? t('placeholder_search_box')
        : `${t('placeholder_search_box')} (${t('placeholder_search_box_min')} ${searchingQueryCharNumber} ${t('placeholder_search_box_char')})`
    const safeStr = companyInfoData.topBarLogoSourceWhiteMode || ''
    const logoPath = companyInfoData ? safeStr.replace('../', '') : ''
    const basketVisibility = authState.custId ? '' : 'hidden'

    return (<>
        <div className="container-fluid mobile-top-bar fixed-top">
            <div className="row">
                <div className="col-6" onClick={() => handleReDirect('/', true)}>
                    <img className="img-fluid element-pointer" src={`${process.env.PUBLIC_URL}/${logoPath}`} alt='logo' height={68} style={{ padding: '5px', maxWidth: '265px' }} />
                </div>
                <div className={`col-6 element-pointer d-flex justify-content-end align-items-center`}>
                    <div className={`${basketVisibility} me-2 me-md-4`}>
                        <NotificationSection
                            isMobile={true}
                        />
                    </div>
                    {isOptionsExpended ?
                        <RxCross2 size={35} color="var(--primary)" onClick={() => setIsOptionsExpended(prev => !prev)} />
                        :
                        <CiMenuFries size={35} color="var(--primary)" onClick={() => setIsOptionsExpended(prev => !prev)} />}
                </div>
            </div>
            <div className="row">
                <div className="col d-flex justify-content-between">
                    <div>
                        {authState.user && authState.user.isOperator && <span className="me-4" style={{ fontWeight: 'bold' }}>Tryb PH</span>}
                    </div>
                    <div className="pe-3">
                        <WarehouseSelector
                            authState={authState}
                            setShowWarehouseSelectorModal={setShowWarehouseSelectorModal}
                            setShowZipCodeInput={setShowZipCodeInput}
                        />
                        <MobileWarehouseSelectorModal
                            show={showWarehouseSelectorModal}
                            setShow={setShowWarehouseSelectorModal}
                        />
                        <ZipCodeInputModal
                            show={showZipCodeInput}
                            onHide={() => setShowZipCodeInput(false)}
                        />
                    </div>
                </div>
            </div>
        </div>
        <div className="container-fluid">
            <div className="row position-relative" style={{ backgroundColor: 'white' }}>
                <div className="col-10 mobile-top-bar-searching">
                    <div className="col">
                        <input
                            type='text'
                            required={true}
                            placeholder={searchPlaceholderText}
                            value={textSearch}
                            onChange={(e) => setTextSearch(e.target.value)}
                            onKeyDown={(e) => handleSearch(e, false)}
                            style={{ width: '100%' }}
                            onFocus={() => setHideProductList(false)}
                        />
                    </div>
                    <div className="col-auto d-flex align-items-center justify-content-center">
                        <RxCross2 size={22} className='element-pointer' color='var(--primary)' onClick={() => handleCleatQuery()} />
                    </div>
                </div>
                <div className="col-2 mobile-top-bar-searching-icon-holder d-flex align-items-center justify-content-center element-pointer pt-2 pb-2" onClick={() => handleSearch()}>
                    <GoSearch size={25} color="white" />
                </div>
                {!hideProductList && loading && textSearch.length >= searchingQueryCharNumber && <LoadingSpinner />}
                {!hideProductList && !loading && isProductsLoaded && textSearch.length >= searchingQueryCharNumber &&
                    <TopBarMobileSearchingResults
                        loading={loading}
                        phrases={result}
                        products={products}
                        suppliers={productsRelatesSuppliers}
                        categories={productsCategories}
                        textSearch={textSearch}
                        handleSearch={handleSearch}
                        searchingProductRef={searchingProductRef}
                        setHideProductList={setHideProductList}
                    />
                }
            </div>
        </div>
        {isOptionsExpended && <TopBarMobileOptions
            handleReDirect={handleReDirect}
            setIsOptionsExpended={setIsOptionsExpended}
            topBarOptionsRef={topBarOptionsRef}
            isOptionsExpended={isOptionsExpended}
        />}
    </>)
}

const WarehouseSelector = ({ authState, setShowWarehouseSelectorModal, setShowZipCodeInput }) => {
    const { findSelectedWarehouseName } = useWarehouseOperations()

    if ((authState.user && authState.siteId)) {
        return <span className="element-pointer" onClick={() => setShowWarehouseSelectorModal(true)}>{`${findSelectedWarehouseName(authState.whId)}`}</span>
    }
    else {
        const wareHouseText = !authState.whId ? 'Zlokalizuj magazyn' : findSelectedWarehouseName(authState.whId)
        return <span className="element-pointer" onClick={() => setShowZipCodeInput(true)}>{wareHouseText}</span>
    }
}

export default TopBarMobile